import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "watchlist-order__header" };
const _hoisted_2 = { class: "watchlist-order__subtitle" };
const _hoisted_3 = { class: "watchlist-order__title" };
const _hoisted_4 = {
    key: 0,
    class: "watchlist-order__content"
};
const _hoisted_5 = { class: "watchlist-order__items" };
const _hoisted_6 = {
    key: 1,
    class: "watchlist-order__footer"
};
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "watchlist-order__delivery_date" };
const _hoisted_9 = { class: "watchlist-order__delivery_date_selection" };
const _hoisted_10 = { class: "watchlist-order__date_input_wrapper" };
const _hoisted_11 = ["value"];
const _hoisted_12 = {
    class: "modal__title",
    style: { "padding": "0", "margin": "0" }
};
import { onMounted, ref } from 'vue';
import { useRoute } from "vue-router";
import WatchlistOrderItem from "../components/WatchlistOrderItem.vue";
import customers from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import PurchaseWatchlistOrder from "../commands/PurchaseWatchlistOrder";
import Modal from "@astina/paloma-common-ui/src/components/Modal.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistOrderView',
    setup(__props) {
        const route = useRoute();
        const watchlist = ref(null);
        const cartItems = ref([]);
        const purchaseCommand = ref(null);
        const showPurchaseModal = ref(false);
        const purchasing = ref(false);
        const error = ref(false);
        const deliveryDates = ref([]);
        const selectedDate = ref(null);
        onMounted(init);
        function onPurchaseStart() {
            events.$emit('app.alert-clear-all');
            purchasing.value = true;
            showPurchaseModal.value = true;
        }
        function onPurchaseSuccess() {
            purchasing.value = false;
            showPurchaseModal.value = true;
            init();
        }
        function onPurchaseError() {
            purchasing.value = false;
            showPurchaseModal.value = false;
        }
        function goToDeliveryDay(deliveryDay) {
            const index = deliveryDates.value.indexOf(deliveryDay);
            if (index > -1) {
                selectedDate.value = deliveryDates.value[index];
                purchaseCommand.value.deliveryDate = selectedDate.value;
            }
        }
        function init() {
            const accessToken = RouterUtils.singleParam(route, 'token');
            watchlist.value = null;
            cartItems.value = [];
            error.value = false;
            customers.getWatchlistByAccessToken(accessToken)
                .then(watchlistParam => {
                watchlist.value = watchlistParam;
                purchaseCommand.value = new PurchaseWatchlistOrder(watchlistParam.accessToken, cartItems.value);
                loadDeliveryDaysAfter(watchlist.value);
            })
                .catch(() => error.value = true);
            events.$on('app.shipping-target-date-error', (nextDeliveryDay) => goToDeliveryDay(nextDeliveryDay));
        }
        /**
         * This is also called when WatchlistOrderItem is rendered.
         */
        function onItemQuantityChange(item, quantityOrPortions) {
            const cartItem = cartItems.value.find(cartItem => {
                return cartItem.watchlistItemId === item.id;
            });
            if (cartItem) {
                if (item.portionSize) {
                    cartItem.portions = quantityOrPortions;
                    cartItem.quantity = calculateQuantityForPortion(quantityOrPortions, item);
                }
                else {
                    cartItem.quantity = quantityOrPortions;
                }
            }
            else {
                cartItems.value.push({
                    watchlistItemId: item.id,
                    sku: item.sku,
                    unit: item.unitCode,
                    portions: item.portionSize ? quantityOrPortions : undefined,
                    quantity: item.portionSize ? calculateQuantityForPortion(quantityOrPortions, item) : quantityOrPortions,
                });
            }
        }
        function hasPreviousDate() {
            return deliveryDates.value != null && selectedDate.value != null && deliveryDates.value.indexOf(selectedDate.value) > 0;
        }
        function hasNextDate() {
            return deliveryDates.value != null && selectedDate.value != null && deliveryDates.value.indexOf(selectedDate.value) < deliveryDates.value.length - 1;
        }
        function nextDate() {
            if (hasNextDate() && deliveryDates.value != null && selectedDate.value != null) {
                selectedDate.value = deliveryDates.value[deliveryDates.value.indexOf(selectedDate.value) + 1];
            }
            purchaseCommand.value.deliveryDate = selectedDate.value;
        }
        function previousDate() {
            if (hasPreviousDate() && deliveryDates.value != null && selectedDate.value != null) {
                selectedDate.value = deliveryDates.value[deliveryDates.value.indexOf(selectedDate.value) - 1];
            }
            purchaseCommand.value.deliveryDate = selectedDate.value;
        }
        function loadDeliveryDaysAfter(watchlist) {
            customers.getDeliveryDaysAfter(watchlist.channel, watchlist.customerId, new Date())
                .then(deliveryDays => {
                deliveryDates.value = deliveryDays;
                if (deliveryDates.value && deliveryDates.value.length > 0) {
                    selectedDate.value = deliveryDates.value[0];
                    purchaseCommand.value.deliveryDate = selectedDate.value;
                }
            })
                .catch(() => error.value = true);
        }
        function calculateQuantityForPortion(portions, item) {
            let quantity = portions * item.portionSize;
            const orderingUnit = item.variant && item.variant.orderingUnits.find(ou => ou.unitCode === item.unitCode);
            if (orderingUnit && orderingUnit.unitDecimals) {
                quantity = parseFloat(quantity.toFixed(orderingUnit.unitDecimals));
            }
            return quantity;
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["watchlist-order", { 'watchlist-order--with-delivery-target-date': selectedDate.value }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    (watchlist.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(watchlist.value.customerName), 1),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_3, _toDisplayString(watchlist.value.publicName || watchlist.value.name), 1)
                        ], 64))
                        : (!error.value)
                            ? (_openBlock(), _createBlock(Spinner, {
                                key: 1,
                                loading: true
                            }))
                            : _createCommentVNode("", true),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    (error.value)
                        ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 2 }))
                        : _createCommentVNode("", true)
                ]),
                _cache[12] || (_cache[12] = _createTextVNode()),
                (watchlist.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(watchlist.value.items, (item, index) => {
                                return (_openBlock(), _createBlock(WatchlistOrderItem, {
                                    key: index,
                                    item: item,
                                    watchlist: watchlist.value,
                                    onQuantityChange: onItemQuantityChange
                                }, null, 8, ["item", "watchlist"]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[13] || (_cache[13] = _createTextVNode()),
                (purchaseCommand.value)
                    ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
                        (selectedDate.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('orders.desired_delivery_date')), 1),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("a", {
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (previousDate()), ["prevent"])),
                                        class: _normalizeClass(["button button--icon", { 'button--disabled': !hasPreviousDate() }]),
                                        href: ""
                                    }, [
                                        _createVNode(_component_icon, { name: "angle-left" })
                                    ], 2),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("input", {
                                            disabled: "",
                                            class: "watchlist-order__date_input",
                                            value: _ctx.$date(selectedDate.value, 'dd, DD. MMM YYYY'),
                                            type: "text"
                                        }, null, 8, _hoisted_11)
                                    ]),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    _createElementVNode("a", {
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (nextDate()), ["prevent"])),
                                        class: _normalizeClass(["button button--icon", { 'button--disabled': !hasNextDate() }]),
                                        href: ""
                                    }, [
                                        _createVNode(_component_icon, { name: "angle-right" })
                                    ], 2)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        _createVNode(CommandButton, {
                            command: purchaseCommand.value,
                            classes: "button button--primary button--large",
                            "tab-index": 2,
                            onExecute: onPurchaseStart,
                            onSuccess: onPurchaseSuccess,
                            onError: onPurchaseError
                        }, null, 8, ["command"])
                    ]))
                    : _createCommentVNode("", true),
                _cache[14] || (_cache[14] = _createTextVNode()),
                (showPurchaseModal.value)
                    ? (_openBlock(), _createBlock(Modal, {
                        key: 2,
                        onClose: _cache[3] || (_cache[3] = ($event) => (showPurchaseModal.value = false)),
                        classes: ['modal--medium'],
                        unclosable: true
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t('orders.purchase_success')), 1)
                        ]),
                        content: _withCtx(() => [
                            (purchasing.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('please_wait')) + " ", 1),
                                    _createVNode(Spinner, { loading: true })
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('orders.watchlist_purchase_success_info')), 1),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createElementVNode("a", {
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (showPurchaseModal.value = false), ["prevent"])),
                                        class: "button"
                                    }, _toDisplayString(_ctx.$t('back')), 1)
                                ], 64))
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
